<template>
  <div class="header-contact">
    <a
      title="Infolinia: 71 771 76 21"
      href="tel:717717621"
      class="header-contact__phone"
    >
      <div class="header-contact__phone-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 32 32"
        >
          <path
            class="pr-color"
            d="M29.5 15.4c-1-6.3-6.1-12-13.3-13l.3-2.4A18.3 18.3 0 0132 15l-2.5.4zm-4 0l-2.4.5a8.5 8.5 0 00-7.3-7l.4-2.5a11 11 0 019.3 9zM16.4 23c1.5.9 1.9 1 2.2.7l2.3-2.4c1-1 2.4-1 3.4 0l3.8 3.8c1.1 1 1 2.4 0 3.4L26 30.6a4.3 4.3 0 01-3.7 1.4c-2-.1-4-.8-5.8-1.7A32 32 0 01.9 13.6C.3 12-.1 10.5 0 8.8 0 7.8.5 7 1.2 6.2l2.4-2.4c1-1 2.3-1 3.4 0l3.8 3.8c1 1.1 1 2.4 0 3.5l-2.4 2.3s-1 .4 2 4c1.7 2.2 3.7 4 6 5.5z"
          />
        </svg>
      </div>
      <span class="header-contact__phone-number d-none d-sm-block"
        >71 771 76 21</span
      >
    </a>
    <div class="header-contact__hours d-none d-md-block">
      Obsługa telefoniczna: pn.-sb. 9:00-22:00, nd. 10:00-21:00
    </div>
  </div>
</template>

<script>
export default {
  name: "header-contact",
};
</script>

<style lang="scss" scoped>
.header-contact {
  display: flex;
  flex-direction: column;
  justify-content: center;

  &__phone {
    color: #fff;
    display: flex;
    margin-left: auto;
    height: 25px;
    line-height: 27px;
    text-decoration: none;

    @media (min-width: $screen-md) {
      color: $text-color-default;

      &:hover {
        color: $blue-light;
      }
    }
  }

  &__phone-icon {
    margin: auto 0;
    width: 24px;
    height: 100%;
    padding-top: 1px;
  }

  &__phone-number {
    font-size: 24px;
    margin-left: 8px;
  }

  &__hours {
    color: #fff;
    font-size: 12px;
    padding-top: 4px;

    @media (min-width: $screen-md) {
      color: $text-color-default;
    }
  }

  .pr-color {
    fill: #fff;
    @media (min-width: $screen-md) {
      fill: $blue-light;
    }
  }
}
</style>
